<template>
  <div class="cart-wrapper">
    <!-- 购物车有数据 -->
    <template v-if="cartInfo && cartInfo.list && cartInfo.list.length">
      <div class="cart-container">
        <h1 class="cart-header">购物车</h1>
        <div class="cart-checkout">
          <button class="checkout" @click="toCheckout">立即结算</button>
        </div>
        <div class="cart-main">
          <!-- 购物车列表 -->
          <div class="cart-items">
            <div class="flex-row cart-thead">
              <div class="th item-image">商品名称</div>
              <div class="item-other flex-row">
                <div class="th item-extra"></div>
                <div class="th item-price">价格</div>
                <div class="th item-count">数量</div>
                <div class="th item-total">总计</div>
              </div>
            </div>
            <div class="cart-item" v-for="(item, i) in cartInfo.list" :key="i">
              <div class="flex-row cart-item-content">
                <div class="td item-image">
                  <img :src="item.images[0]" />
                  <div class="item-action-m is-mobile">
                    <button class="item-action item-edit" @click="editCartItem(item)">
                      编辑
                    </button>
                    <button class="item-action" @click="removeCartItem(item, { done: true })">
                      删除
                    </button>
                  </div>
                </div>
                <div class="item-other flex-row">
                  <div class="td item-extra">
                    <div class="item-sku-info">
                      <template v-if="Array.isArray(item.custom_tags) && calcIsShowCustomerTag && item.custom_tags">
                        <div v-for="(label, index) in item.custom_tags" :key="'custom' + index" class="item-tag custom-tags is-mobile">
                          {{ label }}
                        </div>
                      </template>
                      <div class="item-name"  @click="goDetail(item)">{{ item.name }}</div>
                      <ProductLabel :product-label="item.product_label" />
                      <template v-if="Array.isArray(item.custom_tags) && calcIsShowCustomerTag && item.custom_tags">
                        <div v-for="(label, index) in item.custom_tags" :key="'custom' + index" class="item-tag custom-tags is-desktop">
                          {{ label }}
                        </div>
                      </template>
                      <div class="td item-price is-mobile">
                        <p><span class="rmb-symbol">￥</span>{{ item.price }}</p>
                        <p class="item-original_price" v-if="isShowOriginalPrice(item)">
                          ￥{{ (item.original_price || 0) | filterPrice }}
                        </p>
                      </div>
                      <div class="item-attr is-desktop">
                        <span class="item-attr-name">颜色</span>:
                        <span class="item-attr-value">{{ item.color.name }}</span>
                      </div>
                      <div class="item-attr is-desktop">
                        <span class="item-attr-name">尺码</span>:
                        <span class="item-attr-value">{{ item.size.name }}</span>
                      </div>
                      <button class="item-action item-edit is-desktop" @click="editCartItem(item)">
                        编辑
                      </button>
                    </div>
                  </div>
                  <div class="td item-price is-desktop">
                    <p><span class="rmb-symbol">￥</span>{{ item.price }}</p>

                    <p class="item-original_price" v-if="isShowOriginalPrice(item)">
                      ￥{{ (item.original_price || 0) | filterPrice }}
                    </p>
                  </div>
                  <div class="td item-price is-mobile">
                    <div class="item-attr">
                        <span class="item-attr-name">颜色</span>:
                        <span class="item-attr-value">{{ item.color.name }}</span>
                      </div>
                      <div class="item-attr">
                        <span class="item-attr-name">尺码</span>:
                        <span class="item-attr-value">{{ item.size.name }}</span>
                      </div>
                  </div>
                  <div class="td item-count">
                    <p class="item-label-mobile">
                      <span>数量</span>
                      <span v-if="isNumber(item.limit_qty)" class='limit-text-mobile'>同款限购{{ item.limit_qty }}件</span>
                    </p>
                    <template v-if="item.size.stock > 0">
                      <div class="select-style">
                        <select v-model="item.quantity" @change="setQuantity(item, $event)">
                          <option v-for="i in getItemCounterMax(item)" :key="`item_${item.id}-quantity_${i}`"
                            :value="i">
                            {{ i }}
                          </option>
                        </select>
                      </div>
                    </template>
                    <template v-else>
                      <div class="no-stock">暂无库存</div>
                    </template>
                    <p v-if="isNumber(item.limit_qty)" class='limit-text-desktop'>同款限购{{ item.limit_qty }}件</p>
                    <button class="item-action is-desktop" @click="removeCartItem(item, { done: true })">
                      删除
                    </button>
                  </div>
                  <div class="td item-total">
                    <span class="rmb-symbol">￥</span>{{ item.total }}
                  </div>
                </div>
              </div>
              <p class="markdown-tip" v-if="item.is_mark_down"><span
                  class="iconfont-ot-website">&#xe60f;</span><span>折扣商品不可与其他活动同时享受折扣</span></p>
            </div>
          </div>
          <!-- 购物车小计、合计等信息 -->
          <div class="cart-extra">
            <div class="cart-summary-header">订单总计</div>
            <div class="cart-subtotals">
              <div class="order-subtotal kv-line">
                <span>商品总额</span>
                <span><span class="rmb-symbol">￥</span>{{ cartInfo.amount }}</span>
              </div>
              <div class="order-shipping kv-line">
                <span>运费</span>
                <span><span class="rmb-symbol">￥</span>{{ cartInfo.shipping }}</span>
              </div>
            </div>
            <div class="cart-total kv-line">
              <span>总计</span>
              <span><span class="rmb-symbol">￥</span>{{ cartInfo.subTotal }}</span>
            </div>
            <button class="checkout" @click="toCheckout">立即结算</button>
            <button class="continue" @click="goShopping">继续购物</button>
          </div>
        </div>
      </div>
      <div class="browse-history">
        <RecentlyViewed />
      </div>
      <!-- 编辑购物车记录弹框 -->
      <div class="dialog view-item-dialog" v-if="editingItem && editingItem.id && editingItem.color">
        <div class="mask"></div>
        <div class="dialog-container">
          <div class="dialog-header">
            <div class="dialog-title">商品信息</div>
            <button type="button" class="dialog-close" @click="closeSKUDialog">
              <span class="close-icon"></span>
            </button>
          </div>
          <div class="dialog-body">
            <ViewItemInfo scope="cart" :id="editingItem.id" :color="editingItem.color" :size="editingItem.size"
              :count="editingItem.count" confirmText="更新购物车" @notify="showNotify" @confirm="confirm" />
          </div>
        </div>
      </div>
      <!-- 到货通知 -->
      <div class="dialog notify-dialog" v-if="notifyItem">
        <div class="mask"></div>
        <div class="dialog-container">
          <div class="dialog-header">
            <div class="dialog-title">到货通知</div>
            <button class="dialog-close" @click="hideNotifyDialog">
              <span class="close-icon"></span>
            </button>
          </div>
          <div class="dialog-body">
            <ItemNotify :source="notifyItem" @confirm="sendNotify" />
          </div>
        </div>
      </div>
      <!-- 登录弹窗 -->
      <div class="dialog dialog-login" v-if="showLogin">
        <div class="mask"></div>
        <div class="dialog-container">
          <div class="dialog-header">
            <i class="iconfont dialog-close" @click="hideLoginDialog">&#xe612;</i>
          </div>
          <div class="dialog-body">
            <Login :returnUrl="returnUrl" />
          </div>
        </div>
      </div>
    </template>
    <!-- 购物车空状态 -->
    <template v-else>
      <div class="cart-empty">
        <h1 class="empty-hits">您的购物车为空</h1>
        <template v-if="isLogin">
          <div class="btns-group">
            <button class="continue-shopping" @click="goShopping">
              继续购物
            </button>
          </div>
        </template>
        <template v-else>
          <div class="cart-empty-hits">请登录账户查看你购物车</div>
          <div class="btns-group">
            <button class="user-login" @click="goLogin">登录账户</button>
            <button class="continue-shopping" @click="goShopping">
              继续购物
            </button>
          </div>
        </template>
        <Recommond />
      </div>
    </template>
  </div>
</template>

<script>
import Recommond from "@/components/Recommend.vue";
import ProductLabel from '@/components/ProductLabel.vue';
import RecentlyViewed from "@/components/RecentlyViewed.vue";
import ViewItemInfo from "@/components/ViewItemInfo.vue";
import ItemNotify from "@/components/ItemNotify.vue";
import Login from "@/components/Login.vue";
import api from "@/utils/api";
import utils from "@/utils";
import types from "@/store/types";
import { isNumber } from 'lodash'
export default {
  name: "CartList",
  components: { RecentlyViewed, ProductLabel, Recommond, ViewItemInfo, ItemNotify, Login },
  data() {
    return {
      // 弹窗
      editingItem: null, // 编辑购物车记录 - 商品信息(id,color)
      notifyItem: null, // 到货通知 - 商品信息
      showLogin: false, // 登录弹窗
      returnUrl: "",
    };
  },
  created() { },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    isNumber: isNumber,
    // 修改数量
    setQuantity(info, evt) {
      let dom = evt.target || evt.srcElement;
      this.updateItemCount(info, dom.value);
    },
    // 编辑购物车中的记录：显示商品SKU选择弹层
    editCartItem(info) {
      let { id, goodsId, color, size, quantity } = info;
      this.editingItem = {
        cartId: id,
        id: goodsId,
        color: color.id,
        size: size.id,
        count: quantity,
        goodsId,
      };
    },
    // 显示到货通知弹窗
    showNotify(info) {
      if (!info || !info.id) return console.warn("缺少商品信息"), false;
      this.editingItem = null;
      this.notifyItem = info;
    },
    // 确认更新购物车
    confirm(args) {
      // eslint-disable-next-line no-unused-vars
      let { info, color, size, quantity } = args;
      let oid = this.editingItem.cartId;
      let nid = size.id;
      // 删除老数据，添加新数据
      if (oid != nid) {
        this.delCart(
          {
            id: oid,
          },
          {
            done: false,
            callback: () => {
              this.addToCart(
                {
                  id: nid,
                  name: info.name,
                  price: info.price,
                  quantity,
                  goodsId: info.id,
                  color,
                  category: info.category?.name,
                },
                () => {
                  this.$store.dispatch(types.GET_CART_INFO);
                  this.$message({ message: "更新成功" });
                  this.closeSKUDialog();
                }
              );
            },
          }
        );
      } else {
        this.updateItemCount(
          {
            id: oid,
            price: info.price,
          },
          quantity,
          () => {
            this.closeSKUDialog();
          }
        );
      }
    },
    // 关闭商品SKU选择弹层
    closeSKUDialog() {
      this.editingItem = null;
    },
    // 删除购物车中的记录
    removeCartItem(info) {
      this.$confirm("确定要从购物车删除该商品吗？")
        .then(() => {
          this.delCart(info, { done: true });
        })
        .catch(() => { });
    },
    // 根据ID或SKU删除购物车中的记录
    delCart(info, options) {
      let { id } = info;
      if (this.isLogin) {
        api[types.DEL_CART]({ id })
          .then((res) => {
            if (res?.code == 1) {
              if (options?.done) {
                this.$message({ message: "删除成功" });
                this.$store.dispatch(types.GET_CART_INFO);
              }
              typeof options?.callback == "function" && options.callback();
              //
              this.gaTrack4RemoveFromCart({
                id: `${info.goodsId}-${info.color.id}`,
                name: info.name,
                price: info.price,
                quantity: info.quantity,
                variant: info.color?.name,
              });
            } else {
              console.warn(res);
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        utils.delCart(id, () => {
          if (options?.done) {
            this.$message({ message: "删除成功" });
            this.$store.dispatch(types.GET_CART_INFO);
          }
          typeof options?.callback == "function" && options.callback();
        });
      }
    },
    addToCart(info, callback) {
      let { id, price, quantity } = info;
      if (this.isLogin) {
        api[types.ADD_TO_CART]({ id, quantity })
          .then((res) => {
            if (res?.code == 1) {
              typeof callback == "function" && callback();
              //
              this.gaTrack4AddToCart({
                id: `${info.goodsId}-${info.color?.id}`,
                name: info.name,
                price,
                quantity,
                category: info.category,
                variant: info.color?.name,
              });
            } else {
              console.warn(res);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        let newArgs = {
          id: id,
          price: price || "0.00",
          quantity,
        };
        utils.addToCart(newArgs, callback);
      }
    },
    // 更新购物车记录的商品数量
    updateItemCount(info, count, callback) {
      let { id, price } = info;
      if (this.isLogin) {
        api[types.UPDATE_OPTION]({
          id: id,
          quantity: count,
        })
          .then((res) => {
            if (res?.code == 1) {
              this.$store.dispatch(types.GET_CART_INFO, () => {
                this.$message({ message: "更新成功", type: "success" });
              });
              //
              typeof callback == "function" && callback();
            } else {
              console.warn(res);
            }
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        utils.updateCart(
          {
            oid: id,
            nid: id,
            price: price || "0.00",
            quantity: count,
          },
          () => {
            this.$store.dispatch(types.GET_CART_INFO, () => {
              this.$message({ message: "更新成功", type: "success" });
            });
            //
            typeof callback == "function" && callback();
          }
        );
      }
    },
    gaTrack4AddToCart(info) {
      if (info?.id && window.gtag) {
        window.gtag("event", "add_to_cart", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          value: Number(info.price),
          items: [
            {
              item_id: info.id,
              item_name: info.name,
              item_brand: "Onitsuka Tiger",
              item_category: info.category,
              item_variant: info.variant,
              price: Number(info.price),
              quantity: Number(info.quantity),
              currency: "CNY",
            },
          ],
        });
      }
    },
    gaTrack4RemoveFromCart(info) {
      if (info?.id && window.gtag) {
        window.gtag("event", "remove_from_cart", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          value: Number(info.price),
          items: [
            {
              item_id: info.id,
              item_name: info.name,
              price: Number(info.price),
              quantity: Number(info.quantity),
              item_brand: "Onitsuka Tiger",
              item_category: info.category,
              item_variant: info.variant,
            },
          ],
        });
      }
    },
    // 关闭到货通知弹窗
    hideNotifyDialog() {
      this.notifyItem = null;
    },
    // 结算
    toCheckout() {
      if (this.isLogin) {
        let params = {}
        api[types.CONFIRM](params).then(async res => {
          if (res?.code == 1) {
            const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
            this.$router.push({ path: `/checkout?confirmCacheKey=${confirmCacheKey}` });
          } else {
            console.warn(res);
          }
        })
      } else {
        this.showLoginDialog();
      }
    },
    // 继续购物
    goShopping() {
      this.$router.push({ path: "/" });
    },
    // 显示登录弹窗
    showLoginDialog() {
      this.returnUrl = encodeURIComponent("/checkout");
      this.showLogin = true;
    },
    goLogin() {
      this.$router.push({
        name: "Login",
        query: {
          returnUrl: encodeURIComponent(this.$route.fullPath),
        },
      });
    },
    // 关闭登录弹窗
    hideLoginDialog() {
      this.returnUrl = "";
      this.showLogin = false;
    },
    // 到货通知设置成功
    sendNotify() {
      this.hideNotifyDialog();
    },
    getItemCounterMax(item) {
      const maxStock = 6; // SKU 最多购买六件
      const limitQty = isNumber(item.limit_qty) ? item.limit_qty : Infinity;
      return Math.max(item.quantity || 0, Math.min(maxStock, item.size.stock, limitQty,));
    },
    goDetail(item) {
      if (!item?.goodsId || !item?.color?.id) {
        return
      }
      if(Number(item.skc_status) === 0){
        //skc下架
        return
      }
      this.$router.push({ path: `/detail/${item.goodsId}-${item.color.id}` });
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
    cartInfo() {
      return this.$store.state.cartInfo;
    },
    isH5() {
      return window.innerWidth <= 768; // && (utils.isMobile() || utils.isWXBrowser());
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-wrapper {
  box-sizing: border-box;
  max-width: 1200px;
  padding: 0 10px;
  margin: auto;
  text-align: left;

  .cart-container {
    margin: 30px 0 0 0;
    padding: 0 0 20px;
    position: relative;

    .cart-header {
      font-weight: 400;
      font-size: calc(1.5rem * 1.6);
      color: #333;
      margin: 20px 0 25px;
    }

    .cart-error {
      background-color: #fff;
      border: 1px solid #bd0025;
      border-radius: 0.5em;
      margin: 0.5em 0;
      padding: 0.8em;
    }

    .cart-checkout {
      margin-top: 0.5rem;
      padding-bottom: 1em;
      position: relative;

      .checkout {
        display: none;
        box-sizing: border-box;
        width: 100%;
        height: 45px;
        padding: 0 30px;
        font-weight: 400;
        font-size: calc(1.125rem * 1.6);
        line-height: 38px;
        color: #fff;
        cursor: pointer;
        background-color: #7f0019;
        border: 1px solid #7f0019;
        border-radius: 2px;
      }
    }

    .cart-main {
      &::after {
        content: "";
        display: table;
        clear: both;
      }

      .cart-items {
        width: 65%;
        float: left;

        .flex-row {
          display: flex;
        }

        .cart-thead {
          .th {
            font-weight: 400;
            font-size: calc(0.875rem * 1.6);
            line-height: calc(1.3125rem * 1.6);
            letter-spacing: 0.025em;
            text-transform: uppercase;
            padding: 15px 0;
            background: none;
            border-bottom: 1px solid #b4b5b4;
            border-top: 1px solid #b4b5b4;
            color: #000;
          }
        }

        .cart-item {
          border-bottom: 1px solid #b4b5b4;

          .markdown-tip {
            display: flex;
            align-items: center;
            color: #212322;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 12px;

            .iconfont-ot-website {
              margin-right: 2px;
            }
          }
        }

        .cart-item-content {

          .td {
            box-sizing: border-box;
            padding: calc(1.25rem * 1.6) 0;

            .no-stock {
              color: red;
            }

            .item-action {
              box-sizing: border-box;
              display: inline-block;
              border-radius: 2px;
              cursor: pointer;
              font-weight: 400;
              font-size: calc(0.75rem * 1.6);
              line-height: 1.5em;
              color: #000;
              text-align: center;
              text-decoration: underline;
              background-color: transparent;
              border-width: 0;
              padding: 0;
              margin-top: calc(0.5rem * 1.6);
            }
          }
        }

        .item-other {
          flex: 1;
        }

        .item-image {
          width: 18%;
          text-align: left;

          &>img {
            width: 100%;
          }
        }

        .item-extra {
          width: 51%;
          text-align: left;

          .item-sku-info {
            line-height: 1.5em;
            padding-right: 10px;

            .item-name {
              font-weight: 400;
              font-size: calc(1rem * 1.6);
              line-height: calc(1.375rem * 1.6);
              color: #000;

              &:hover {
                text-decoration: underline;
              }
            }

            .item-tag {
              font-size: 10px;
              border: 1px solid #212322;
              padding: 0px 5px;
              margin: 4px 0;
              line-height: 18px;
              color: #212322;
              width: fit-content;
            }

            .item-attr {
              .item-attr-name {
                font-weight: 700;
                font-size: calc(0.875rem * 1.6);
                color: #000;
                line-height: 1em;
              }

              .item-attr-value {
                font-weight: 400;
                font-size: calc(0.875rem * 1.6);
                color: #000;
                line-height: 1em;
              }
            }

            .item-edit {
              margin-top: 0;
            }
          }

          &.td {
            padding-left: 25px;
          }
        }

        .item-price {
          width: 17%;
          text-align: left;
          font-weight: 400;
          font-size: calc(1rem * 1.6);
          color: #000;

          &.is-mobile {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .item-original_price {
            color: #999;
            line-height: 20px;
            text-decoration: line-through;
          }
        }

        .item-count {
          width: 14.6%;
          text-align: left;

          .item-label-mobile {
            display: none;
            font-weight: 700;
            font-size: calc(0.75rem * 1.6);
            margin-bottom: 5px;
          }

          .limit-text-desktop {
            color: #E61545;
            margin-top: 8px;
            font-size: calc(0.75rem * 1.6);
            font-weight: 400;
            line-height: calc(1.125rem * 1.6);
          }

          .limit-text-mobile {
            color: #E61545;
            margin-left: 8px;
          }

          .select-style {
            box-sizing: border-box;
            max-width: 72px;
            border: 1px solid #b4b5b4;
            border-radius: 2px;
            overflow: hidden;
            display: block;
            padding-right: 31px;
            background: #fff url(../assets/imgs/icons/onitsukatiger-drop-down-arrow.svg) no-repeat scroll;
            background-position: right 10px center;

            select {
              background: transparent;
              border: none;
              padding: 2px 0 2px 10px;
              height: 38px;
              width: calc(100% + 31px);
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
            }

            select::-ms-expand {
              display: none;
            }
          }
        }

        .item-total {
          width: 14.6%;
          text-align: right;
          font-weight: 700;
          font-size: calc(0.875rem * 1.6);
          color: #000;
        }
      }

      .cart-extra {
        width: 27%;
        padding: 0 10px 10px;
        border: 1px solid #b4b5b4;
        background: #efefef;
        float: right;

        .cart-summary-header {
          font-weight: 700;
          font-size: calc(0.875rem * 1.6);
          border-bottom: 1px solid #b4b5b4;
          color: #000;
          // margin-bottom: 18px;
          padding: 17px 0 15px;
          text-transform: uppercase;
        }

        .kv-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 400;
          font-size: calc(0.875rem * 1.6);
          padding: 5px 0;
          color: #000;
        }

        .cart-subtotals {
          padding: 10px 0;
        }

        .cart-total {
          border-bottom: 1px solid #b4b5b4;
          border-top: 1px solid #b4b5b4;
          font-size: calc(1rem * 1.6);
          font-weight: 400;
          padding: 15px 0;
          margin: 0;
          color: #000;
        }

        .checkout {
          font-weight: 400;
          font-size: calc(1.125rem * 1.6);
          width: 100%;
          height: 45px;
          color: #fff;
          background-color: #7f0019;
          border-color: #7f0019;
          border-radius: 2px;
          line-height: 38px;
          padding: 0 30px;
          margin-top: 20px;
        }

        .continue {
          font-weight: 400;
          font-size: calc(0.875rem * 1.6);
          line-height: 3.25em;
          width: 100%;
          margin-right: 1em;
          text-decoration: underline;
          color: #000;
          margin: 0;
          background-color: transparent;
          border-width: 0;
          padding: 0;
          cursor: pointer;
          display: inline-block;
          box-sizing: border-box;
        }
      }
    }
  }

  .browse-history {
    padding-bottom: 45px;
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
      z-index: 1010;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;
      border-radius: 4px;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-title {
          border-bottom: 1px solid #b4b5b4;
          font-weight: 400;
          font-size: calc(1.375rem * 1.6);
          color: #000;
          text-transform: uppercase;
          padding: calc(1.25rem * 1.6) calc(1.25rem * 1.6) calc(0.5rem * 1.6) 0;
          margin: 0 calc(1.25rem * 1.6);
          width: calc(100% - 40px);
          box-sizing: border-box;
        }

        .dialog-close {
          width: 32px;
          height: 32px;
          position: absolute;
          top: -15px;
          right: -15px;
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
          background-color: transparent;
          font-size: 0;
          cursor: pointer;

          .close-icon {
            background-image: url(../assets/imgs/icons/onitsukatiger-close.svg);
            background-position: 0 0;
            background-repeat: no-repeat;
            height: 32px;
            width: 32px;
            margin: 0;
            padding: 0;
            display: block;
            text-indent: -99999px;
            overflow: hidden;
          }
        }
      }

      .dialog-body {
        display: flex;
        box-sizing: border-box;
      }
    }

    &.view-item-dialog {
      .dialog-container {
        width: 920px;
        border: 1px solid #ddd;
        background: #efefef;

        .dialog-header {
          .dialog-title {
            display: none;
          }
        }

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.notify-dialog {
      .dialog-container {
        width: 834px;
        background-color: #efefef;

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.dialog-login {
      .dialog-container {
        width: 490px;
        height: 600px;

        .dialog-header {
          height: 40px;

          .dialog-close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 32px;
            color: #999999;
            cursor: pointer;
          }
        }

        .dialog-body {

          // padding: 0 45px;
          & ::v-deep .login-component {
            width: 100%;

            .title {
              text-align: center;
            }

            .el-form {
              .others-way {
                .iconfont {
                  text-align: center;
                }
              }
            }
          }
        }
      }
    }
  }

  .cart-empty {
    padding: 30px 0;
    text-align: center;

    .empty-hits {
      font-size: calc(1.5rem * 1.6);
      font-weight: 400;
      color: #000;
      text-align: center;
      text-transform: none;
      line-height: calc(2.5rem * 1.6);
      margin: 0.67em 0;
    }

    .cart-empty-hits {
      width: 60vw;
      margin: 0 auto 0.625rem;
    }

    .btns-group {
      padding: 0.3125rem;

      .user-login {
        cursor: pointer;
        display: inline-block;
        width: calc(20.3125rem * 1.6);
        line-height: calc(1.625rem * 1.6);
        padding: 5px;
        margin: calc(1.3125rem * 1.6) 0;
        margin-right: 10px;
        font-weight: 400;
        font-size: calc(0.875rem * 1.6);
        letter-spacing: normal;
        border-radius: 2px;
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        transition: all 0.3s ease;
        color: #fff;
        background-color: #000000;
        border: 1px solid #000000;
      }

      .continue-shopping {
        cursor: pointer;
        display: inline-block;
        box-sizing: border-box;
        width: calc(20.3125rem * 1.6);
        line-height: calc(1.625rem * 1.6);
        padding: 5px;
        margin: calc(1.3125rem * 1.6) 0;
        font-weight: 400;
        font-size: calc(0.875rem * 1.6);
        letter-spacing: normal;
        border-radius: 2px;
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        transition: all 0.3s ease;
        color: #fff;
        background-color: #7f0019;
        border: 1px solid #7f0019;
      }
    }

    & ::v-deep .recommend-container {
      margin-top: calc(1.5625rem * 1.6);
      padding: 10px 30px 30px 30px;
      background-color: #ededed;
    }
  }
}

@media only screen and (max-width: 768px) {
  .cart-wrapper {
    .cart-container {
      .cart-main {
        .cart-items {
          width: 55%;

          .cart-thead {
            display: none;
          }

          .cart-item-content {
            // align-items: center;
            justify-content: space-between;

            .item-image {
              width: 133px;
              height: auto;
            }

            .item-other {
              flex-direction: column;

              .item-extra {
                width: 100%;
                padding: 10px 0 10px 25px;
              }

              .item-price {
                width: 100%;
                padding: 0 0 10px 25px;
              }

              .item-count {
                width: 100%;
                padding: 0 0 10px 25px;
              }

              .item-total {
                width: 100%;
                padding: 0 0 10px 25px;
                text-align: left;
              }
            }
          }
        }

        .cart-extra {
          width: 36%;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .is-desktop  { 
    display: none !important;
  }
  // .is-mobile  { 
  //   display: block !important;
  // }
  .cart-wrapper {
    .cart-container {
      .cart-checkout {
        .checkout {
          display: block;
        }
      }

      .cart-main {
        .cart-items {
          width: 100%;

          .cart-thead {
            display: none;
          }

          .cart-item {
            .markdown-tip {
              font-size: 12px;
              line-height: 18px;
              margin-bottom: 10px;

              .iconfont-ot-website {
                font-size: 12px;
              }
            }
          }

          .cart-item-content {
            margin-bottom: 20px;
            .item-image {
              // width: 42%;
              display: flex;
              align-items: center;
              flex-direction: column;
              margin-top: 30px;
            }

            .item-action-m{
              display: flex;
              flex-direction: row;
              align-items: flex-end;
              justify-content: space-around;
              width: 70%;
              height: 100%;
              color: #333;

              .item-action {
                color: #333;
              }

              // gap: 10px;
            }
            .td {
                padding: 0 !important;
            }

            .item-other {
              flex-direction: column;
              gap: 10px;
              margin-left: 20px;
              justify-content: space-between;

              .item-name{
                margin-bottom: 8px;
              }
            

              .item-extra {
                width: 100%;
              }

              .item-price {
                width: 100%;
                padding-left: 25px;
                padding-top: 0;
                color: #4B4F54;
                font-size: 12px;
              }

              .item-count {
                width: 100%;
                padding-left: 25px;
                padding-top: 0;

                .item-label-mobile {
                  display: block;
                }

                .limit-text-desktop {
                  display: none;
                }
              }

              .item-total {
                width: 100%;
                padding-left: 25px;
                padding-top: 0;
                text-align: left;
              }

           
            }
          }
        }
     

        .cart-extra {
          width: 100%;
          box-sizing: border-box;
          margin-top: 20px;
        
        }
      }
    }

    .dialog {
      &.view-item-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
        }
      }

      &.notify-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
          background: #fff;
        }
      }
    }

    .cart-empty {
      .btns-group {
        flex-direction: column;

        .user-login,
        .continue-shopping {
          width: 100%;
          margin: calc(0.3125rem * 1.6) 0;
        }
      }

      & ::v-deep .recommend-container {
        padding: 0 0 30px 0;
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .cart-wrapper {
    .dialog {
      &.view-item-dialog {
        .dialog-container {
          top: 0px;
          width: 100%;
          max-width: 100%;
          background: #fff;
          border-radius: 0;

          .dialog-header {
            .dialog-title {
              display: block;
            }

            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.notify-dialog {
        .dialog-container {
          top: 0px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.dialog-login {
        .dialog-container {
          position: fixed;
          top: 0;
          left: 0;
          transform: none;
          // transform: translate(-50%, 0);
          background: #fff;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-body {
            padding: 10px 0;

            & ::v-deep .login-component {
              .el-form {
                width: calc(100% - 40px);

                .input-item {
                  .el-form-item {
                    .verify-input {
                      min-width: 100px;
                    }

                    &.item-right {
                      width: 135px;
                      flex-grow: unset;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
@media screen and (min-width: 768px) {
  .cart-wrapper .dialog.view-item-dialog .dialog-container {
    top: max(50%, 370px);
  }

  .cart-wrapper .dialog.notify-dialog .dialog-container {
    top: max(50%, 355px);
  }

  /* .is-desktop  { 
    display: block !important;
  } */
  .is-mobile  { 
    display: none !important;
  }
}
</style>
